import styled from 'styled-components'
import PostBanner from '../../assets/blog/posts/Imagenes-Blog1-1200x439.png'

export const PostStyle = styled.section`
  width: 100%;
  padding: 146px 0 0 0;
`;

export const PostStyleContainer = styled.div`
  width: 100%;
  max-width: 1090px;
  margin: 0 auto;
`;

export const Banner = styled.section`
  width: 100%;
  height: 90vh;
  margin: 100px 0;
  background: url(${PostBanner}) top center no-repeat;
  background-size: cover;
`;

export const Title = styled.h1`
  color: #007e78;
  font-size: 50px;
  font-weight: normal;
  margin-bottom: 20px;
  line-height: 0.9;
  letter-spacing: -1px;
  font-family: DomaineSansText-Light;
`;

export const Date = styled.h4`
  color: #273a46;
  font-size: 18px;
  text-align: left;
  letter-spacing: -0.38px;
  font-family: DomaineSansText-Regular;

  span {
    font-weight: 900;
    font-family: DomaineSansText-Black;
  }
`;

export const PreText = styled.p`
  font-size: 20px;
  color: #273a46;
  line-height: 1.5;
  margin-top: 40px;

  // &:first-letter {
  //   font-family: ${props => props.primary ? 'Roboto-Regular' : ''};
  //   color: ${props => props.primary ? '#009f67' : ''};
  //   font-size: ${props => props.primary ? '5.1em' : ''};
  //   font-weight: ${props => props.primary ? 'normal' : ''};
  // }
`;

export const SubTitle = styled.h2`
  color: ${props => props.highlight ? '#000' : '#007e78'};
  font-size: ${props => props.highlight ? '30px' : '40px'};
  font-weight: normal;
  line-height: 1.25;
  letter-spacing: -1.2px;
  font-family: ${props => props.highlight ? '' : 'DomaineSansText-Regular'};
  margin: 50px 0;
`;

export const Text = styled.p`
  color: #273a46;
  line-height: 2;
  font-size: 15px;
  font-weight: normal;
  margin-bottom: 10px;
`;

export const Media = styled.div`
  display: grid;
  width: 100%;
  margin: 50px 0;
  grid-template-rows: auto;
  grid-template-columns: auto 60%;

  p {
    margin-right: 20px;
  }

  img {
    max-width: ${props => props.small ? '350px' : 'auto'}
  }
`;